import { motion } from 'framer-motion';
import { MENU } from './data';

// HOME — letterpress menu sheet (NOT chalkboard, NOT cinematic photo). Big set serif type, copper rules.
export default function Home({ setPage }) {
  const today = new Date().toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' });
  return (
    <div className="bg-[#F0E4D0] text-[#3D2818]">
      {/* LETTERPRESS COVER SHEET */}
      <section className="pt-32 pb-12 max-w-[1500px] mx-auto px-8 lg:px-14">
        <div className="border-y-[6px] border-double border-[#3D2818] py-6 flex flex-wrap items-baseline justify-between gap-4 font-mono text-[10px] tracking-[0.32em] uppercase text-[#3D2818]/65">
          <span>— Bramble & Bean Roastery — No. {Math.floor(Math.random() * 200) + 800} —</span>
          <span className="hidden md:inline">{today} · Greenpoint, Brooklyn</span>
        </div>
        <div className="text-center pt-12">
          <p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#B87333] mb-5">— Single-origin only · Roasted Tue. & Fri. —</p>
          <h1 className="font-serif text-[80px] sm:text-[140px] lg:text-[220px] leading-[0.85] tracking-[-0.03em] text-[#3D2818]">A roastery,<br /><span className="italic text-[#B87333]">an espresso bar,</span><br />a counter.</h1>
          <p className="font-serif italic text-base lg:text-xl text-[#3D2818]/65 mt-7 max-w-xl mx-auto leading-[1.55]">A 1958 Probat in the back. Eighteen origins on the rotation. Pour-overs at the bar from 7am.</p>
          <div className="mt-9 flex flex-wrap justify-center gap-4">
            <button onClick={() => setPage('menu')} data-testid="bb-home-cta" className="bg-[#3D2818] text-[#F0E4D0] px-7 py-3.5 font-mono text-[10px] tracking-[0.32em] uppercase hover:bg-[#B87333] transition-colors">Read the menu →</button>
            <button onClick={() => setPage('beans')} className="font-mono text-[10px] tracking-[0.32em] uppercase border-b-2 border-[#3D2818] text-[#3D2818] pb-1 hover:text-[#B87333] hover:border-[#B87333]">Or the beans →</button>
          </div>
        </div>
      </section>

      {/* PRINTED MENU SHEET — three categories side-by-side */}
      <section className="bg-[#FAF1E0] border-y-[3px] border-[#3D2818] py-14 mt-12">
        <div className="max-w-[1500px] mx-auto px-8 lg:px-14">
          <p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#B87333] mb-2 text-center">— The day's offerings —</p>
          <p className="font-serif italic text-3xl lg:text-4xl text-center text-[#3D2818] mb-9">As printed each morning.</p>
          <div className="grid md:grid-cols-3 gap-x-12 gap-y-8 max-w-5xl mx-auto">
            {Object.entries(MENU).map(([cat, items]) => (
              <div key={cat}>
                <p className="font-serif italic text-3xl text-[#B87333] border-b-2 border-[#3D2818] pb-2 mb-4">{cat}</p>
                <ul className="space-y-3">
                  {items.map(it => (
                    <li key={it.code} className="border-b border-dashed border-[#3D2818]/30 pb-2.5">
                      <div className="flex items-baseline justify-between gap-3"><p className="font-serif text-base text-[#3D2818]">{it.t}</p><p className="font-serif text-base text-[#B87333]">{it.price}</p></div>
                      <p className="font-mono text-[10px] tracking-[0.18em] uppercase text-[#3D2818]/55 mt-0.5">{it.code} · {it.d}</p>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* PROBAT PHOTO + CAPTION */}
      <section className="max-w-[1500px] mx-auto px-8 lg:px-14 py-16 grid lg:grid-cols-[1.2fr_1fr] gap-12 items-center">
        <motion.div initial={{ opacity: 0, x: -16 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} className="aspect-[4/3] overflow-hidden border-[6px] border-[#3D2818]/15">
          <img src="https://images.pexels.com/photos/302899/pexels-photo-302899.jpeg?auto=compress&cs=tinysrgb&w=1400" alt="" className="w-full h-full object-cover sepia-[20%]" />
        </motion.div>
        <div>
          <p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#B87333] mb-3">— A 1958 Probat L12, restored 2014 —</p>
          <h2 className="font-serif italic text-4xl lg:text-6xl leading-[1] text-[#3D2818]">It still smells like 1958.</h2>
          <p className="font-serif text-base text-[#3D2818]/65 mt-5 leading-[1.7] max-w-md">We restored a 1958 Probat L12 the year we opened. It does twelve kilos a batch, four batches a day, twice a week. Our entire output for thirteen hundred subscribers and the bar.</p>
        </div>
      </section>
    </div>
  );
}
